import { Alert, Box, Grid, Snackbar, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { migrateEnv } from "../../apis/createEnvApi/createEnvApi";

const ConfirmKeyvaultMigrate = ({
  data,
  Emp_Id,
  Client_Id,
  Env_Id,
  Env_Name,
}: {
  data: { normalizedData: any[]; defaultValues: any };
  Emp_Id: any;
  Client_Id: any;
  Env_Name: any;
  Env_Id: any;
}) => {
  const [alertOpen, setAlertOpen] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: data.defaultValues,
  });

  const onSubmit = async (formData: FieldValues) => {
    const finalObj = data.normalizedData
      .filter(({ key }) => formData[`${key}_checked`])
      .map(({ key }) => ({
        secretName: key,
        secretValue: formData[`${key}_value`],
      }));
    const body = {
      Emp_Id,
      Client_Id,
      Env_Name,
      Env_Id,
      secrets: finalObj,
    };
    await migrateEnv(body, () => {
      setAlertOpen(true);
    });
  };

  const handleCloseAlert = () => setAlertOpen(false);

  return (
    <>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="success"
          sx={{ width: "100%" }}
        >
          Success! Key migrated successfully.
        </Alert>
      </Snackbar>
      <Box>
        <Typography
          variant="h5"
          textAlign={"center"}
          marginBottom={1}
          fontWeight={600}
        >
          Migrate Key Values
        </Typography>
        <Typography variant="body1" textAlign={"center"} marginBottom={2}>
          Total Keys to be migrated: {data.normalizedData.length}
        </Typography>
        <form action="POST" onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ overflowY: "scroll", maxHeight: "40rem" }}>
            {data.normalizedData.map(({ key, value, prevValue }, index) => (
              <Grid container rowSpacing={1} marginBottom={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }} key={index}>
                <Grid item xs={6} alignItems={'center'} display={'flex'} columnGap={3}>
                  <input type="checkbox" {...register(`${key}_checked`)} />
                  <Box display={'inline-block'} width={"90%"} sx={{overflowWrap: 'anywhere'}} bgcolor={'white'} padding={2} border={1} borderColor={'gray'} borderRadius={2}>
                  <Typography>
                  Prev Value: {prevValue}
                </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>

                <Box className="input-div modal-1-input-div">
                  <label htmlFor={key} className="floating-label">
                    {key}
                  </label>
                  <input
                    {...register(`${key}_value`)}
                    className="input-field-1 "
                    />
                </Box>
                    </Grid>
                
              </Grid>
            ))}
          </Box>
          <Box className="model-1-form-actions center-div">
            <button
              className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
              type="submit"
              disabled={isSubmitting}
            >
              <div>Done</div>
            </button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ConfirmKeyvaultMigrate;
